// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__BtimN","footerLogos":"style__footerLogos__wB3kp","washu":"style__washu__wYlN0","moedc":"style__moedc__c8H0J"};